module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "twui-header xdoc xconsole"
  }, [_c('div', {
    staticClass: "twui-header-inner",
    attrs: {
      "id": "header"
    }
  }, [_c('h1', {
    staticClass: "tw-header-left"
  }, [_c('router-link', {
    staticClass: "twui-header-logo",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.orgLogo
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "tw-header-title"
  }, [_vm._v(_vm._s(_vm.$t('m.platform_name')))])], 1), _vm._v(" "), _vm._l((_vm.menuList), function(item, index) {
    return _c('div', {
      key: index,
      style: ({
        visibility: _vm.isShowMenuLis ? 'visible' : 'hidden'
      })
    }, [_c('div', {
      staticClass: "twui-header-nav"
    }, [(item.menuId === 'TWPAAS11000000003') ? _c('el-dropdown', {
      on: {
        "command": _vm.jumpTo
      }
    }, [_c('span', {
      staticClass: "xrouter"
    }, [_vm._v(_vm._s(item.menuName))]), _vm._v(" "), _c('el-dropdown-menu', {
      attrs: {
        "slot": "dropdown"
      },
      slot: "dropdown"
    }, [_c('el-dropdown-item', {
      staticStyle: {
        "text-align": "left"
      },
      attrs: {
        "command": "0"
      }
    }, [_vm._v(_vm._s(_vm.$t('m.twtymyapi')))]), _vm._v(" "), _c('el-dropdown-item', {
      staticStyle: {
        "text-align": "left"
      },
      attrs: {
        "command": "1"
      }
    }, [_vm._v(_vm._s(_vm.$t('m.twzjk')))])], 1)], 1) : _c('el-button', {
      class: _vm.activeMenuId === item.menuId ? 'xactice-color' : 'xbutton-color',
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.getMenuList(item.menuId)
        }
      }
    }, [_vm._v(_vm._s(item.menuName))])], 1)])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUserImg),
      expression: "showUserImg"
    }],
    staticClass: "twui-header-right"
  }, [(_vm.showDocMMneu) ? _c('el-button', {
    staticClass: "xbutton-color",
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.goto
    }
  }, [_vm._v(_vm._s(_vm.$t('m.document_menu_management')))]) : _vm._e(), _vm._v(" "), _c('tw-lang', {
    ref: "twlang"
  }), _vm._v(" "), _c('div', {
    staticClass: "twui-header-userbox xadmin"
  }, [_c('img', {
    attrs: {
      "src": require("../static/images/nav-headportrait.png"),
      "alt": _vm.$t('m.yhtx')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "twui-header-usermenu"
  }, [_c('div', {
    staticClass: "xhead"
  }, [_c('img', {
    attrs: {
      "src": require("../static/images/nav-headportrait.png"),
      "alt": _vm.$t('m.yhtx')
    }
  }), _vm._v(" "), _c('span', {
    class: {
      xno: !(_vm.orgName != null && _vm.orgName != 'null' && _vm.orgName != 'undefined')
    }
  }, [_vm._v(_vm._s(_vm.username))]), _vm._v(" "), _c('span', {
    staticClass: "xinfo"
  }, [_vm._v(_vm._s(_vm.orgName != null && _vm.orgName != 'null' && _vm.orgName != 'undefined' ? _vm.orgName : ''))])]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "twui-ico xoff"
  }), _vm._v("\n              " + _vm._s(_vm.$t('m.logout')) + "\n            ")])])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showUserImg),
      expression: "!showUserImg"
    }],
    staticClass: "twui-header-right"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.showLogin()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('m.login')))])])], 2)]), _vm._v(" "), _c('div')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-6affc9fd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/tw-header.vue
// module id = 596
// module chunks = 1